import { Corner, PlacementGeometry } from "../types";

/**
 * Возвращает anchor-точку для resize'а: противоположный handle'у угол overlay'а
 * в px-координатах контейнера. При drag за handle дальний угол должен остаться
 * на месте.
 */
export const getCornerAnchor = (
  corner: Corner,
  geom: PlacementGeometry,
): { x: number; y: number } => {
  const x =
    corner === "nw" || corner === "sw"
      ? geom.leftPx + geom.displayW
      : geom.leftPx;
  const y =
    corner === "nw" || corner === "ne"
      ? geom.topPx + geom.displayH
      : geom.topPx;
  return { x, y };
};
